import {AuditService} from "../PA.Core/Security/AuditService";
import {PeriodBO} from './PeriodBO'
import {AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import * as _ from "lodash";
import {WB_PeriodCompanyRelationshipRow} from "../PA.Core/PAdbSchemaRows";
import {esWB_Company} from "../PA.Core/PAdbSchema";


export class PeriodBOAudit {

    // Audit Log Service for Period

    static async PeriodAuditBO(PeriodBO: PeriodBO): Promise<AuditService> {
        const self = PeriodBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("Period", self.drWB_Period.cif.WB_PERIOD_ID)
        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        //Adding new Period on screen
        const periodParams: IAuditField [] = [
            {fieldName: "PERIOD_ID", realName: "ID", bAllMsg: true }, //create
            {fieldName: "PERIOD_NAME", realName: "Name"},
            {fieldName: "PERIOD_START_DT", realName: "Start Date"},
            {fieldName: "PERIOD_END_DT", realName: "End Date"},

        ]
        // Company
        const periodCompany: IAuditField[]= [
            {fieldName: "WB_COMPANY_ID",
                fkMapper: esWB_Company,
                fkMapperNameField: "COMPANY_ID",
                fkMapperIdField: "COMPANY_NAME",
                bAllMsg: true,
                realName: "Company", },
        ]
        await AuditUtils.logRecord(auditService, self.drWB_Period, periodParams,{objectName: 'Period', deletedKeys: deleteKeys})

        // Company
        _.forEach(self.drWB_Period.WB_PeriodCompanyRelationshipRow, async (aPeriodCompanyRelRow: WB_PeriodCompanyRelationshipRow) => {
            await AuditUtils.logRecord(auditService, aPeriodCompanyRelRow, periodCompany, {objectName: 'Company', deletedKeys: deleteKeys})
        })


        return auditService
    }

}